
export enum ValueConsolidationType {
  Average = 1,
  Sum = 2,
  Min = 3,
  Max = 4,
  DailyMax = 5,
  MaxDuration = 6
}
